import React, { useState } from "react";
import styled from "styled-components";
import { WithTooltip } from "../StyledComponents/WithTooltip";
import getStarted from "../../images/getStarted.svg";

const Image_Base_Url = process.env.REACT_APP_IMAGE_BASE_URL;
const DEFAULT_ICON = "category";

function LegacyIconImage({ src, color }) {
  const [error, setError] = useState(false);
  if (error) {
    return (
      <span style={{ fontSize: "40px", height: "40px", color }} className="material-icons-outlined">
        {DEFAULT_ICON}
      </span>
    );
  }
  return (
    <img style={{ width: "40px", height: "40px" }} alt="categoryIcon" src={src} onError={() => setError(true)} />
  );
}

function legacyGetCategoryIcon({ icon, color }) {
  if (!icon) {
    return (
      <span style={{ fontSize: "40px", height: "40px", color }} className="material-icons-outlined">
        {DEFAULT_ICON}
      </span>
    );
  }
  if (icon === "getting-started-icon") {
    return (
      <img style={{ width: "40px", height: "40px" }} alt="categoryIcon" src={getStarted} />
    );
  }
  if (icon.includes("media")) {
    const base = Image_Base_Url?.trim?.() || "";
    if (!base) {
      return (
        <span style={{ fontSize: "40px", height: "40px", color }} className="material-icons-outlined">
          {DEFAULT_ICON}
        </span>
      );
    }
    const sep = base.endsWith("/") ? "" : "/";
    const iconPath = icon.startsWith("/") ? icon.slice(1) : icon;
    return <LegacyIconImage src={`${base}${sep}${iconPath}`} color={color} />;
  }
  return (
    <span style={{ fontSize: "40px", height: "40px", color }} className="material-icons-outlined">
      {icon}
    </span>
  );
}

// ── Old CategoryMeta (no icons, centered, #8F97B2 color, pipe separator) ──
const MetaData = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  margin-top: auto;
`;

const MetaContent = styled.label`
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  color: #8F97B2;
  padding: 0 12px;
  position: relative;
  &:first-child {
    padding-left: 0;
  }
  &:last-child {
    padding-right: 0;
  }
  &:not(:first-child)::before {
    content: '|';
    color: #ECEFF6;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`;

const metaFields = [
  { key: 'immediateSubcategoryCount', getLabel: (count) => count === 1 ? 'category' : 'categories' },
  { key: 'immediateArticleCount', getLabel: (count) => count === 1 ? 'article' : 'articles' },
];

function LegacyCategoryMeta({ categoryData }) {
  return (
    <MetaData>
      {metaFields.map(({ key, getLabel }) => {
        const value = categoryData[key];
        if (!value) return null;
        return (
          <MetaContent key={key}>
            {value} {getLabel(value)}
          </MetaContent>
        );
      })}
    </MetaData>
  );
}

// ── Old widget styles (centered, fixed size, #f9f9f9 bg) ──
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 8px;
  height: 245px;
  width: 303px;
  border-radius: 10px;
  box-sizing: border-box;
  background-color: #f9f9f9;
  padding: 24px 30px 16px;

  @media screen and (max-width: 800px) {
    width: 327px;
  }

  &:hover {
    box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);
  }
`;

const WidgetHead = styled.div`
  flex-shrink: 0;
`;

const WidgetTitle = styled.h1`
  margin: 0;
  padding: 0;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  color: #222222;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const WidgetContent = styled.label`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 173%;
  letter-spacing: 0px;
  text-align: center;
  color: #313c4b;
  cursor: pointer;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default function LegacyCategoryWidget(props) {
  return (
    <Wrapper>
      <WidgetHead>{legacyGetCategoryIcon({ icon: props.icon, color: props.color })}</WidgetHead>
      <WithTooltip
        isNeeded={props?.title.length > 40}
        className="bottom-center"
        content={props?.title}
        size="250px"
      >
        <WidgetTitle>{props?.title}</WidgetTitle>
      </WithTooltip>
      <WithTooltip
        isNeeded={props?.description.length > 60}
        className="bottom-center"
        content={props?.description}
        size="250px"
      >
        <WidgetContent>{props?.description}</WidgetContent>
      </WithTooltip>
      <LegacyCategoryMeta categoryData={props} />
    </Wrapper>
  );
}
